// Copyright 2016 Sorama B.V.

import { IValueConverter } from "aurelia-binding-ext";
import { ChannelSelection } from "services/ChannelSelection/ChannelSelection";

export class MaskToChannelSelectionValueConverter implements IValueConverter<ChannelSelection, boolean[]> {
    public toView(value: boolean[]): ChannelSelection {
        return new ChannelSelection(value);
    }

    public fromView(value: ChannelSelection): boolean[] {
        return value.getSelection();
    }
}
